var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property, query, queryAll } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { html, css } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { booleanDecoder, customElement, PICInputOptions, stringDecoderLC } from '../Internals';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
let PICRadio = class PICRadio extends PICInputOptions {
    get submitValue() {
        for (let i = 0; i < this.radios.length; i++) {
            let radio = this.radios[i];
            if (radio.checked)
                return radio.id;
        }
        return '';
    }
    constructor() {
        super();
        /*@property({reflect: true, attribute: 'options', converter: arrayDecoder}) options_: [string,string][] | null = null;*/
        this.horizontal_ = false;
        this.eType = 'old';
        this.density = 'old';
        this.maxWidth = undefined;
    }
    static get styles() {
        const defaultStyle = css `
        :host{
            --pic-radioBGColor: var(--pic-surfaceColor);
            --pic-radioColor: var(--pic-primaryColor);
            --pic-radioHoverBGColor: var(--pic-primaryHoverColor);
            --pic-radioFocusBGColor: var(--pic-primaryFocusColor);
            --pic-radioActiveBGColor: var(--pic-primaryActiveColor);
            --pic-radioActiveColor: var(--pic-primaryColor);
            --pic-radioDisabledBGColor: var(--pic-primaryActiveColor);
            --pic-radioDisabledColor: var(--pic-disabledBGColor);
            --pic-radioDiabledBorderColor: var(--pic-blackOverlayFocusColor);
            min-width: 40px;
        }
        .inner-input {
            width: 100%;
            box-sizing: border-box;
            font-family: monospace;
        }
        .groupcontainer{
            display: flex;
            justify-content: space-between;
        }
        .horizontal {
            flex-direction: row;
        }
        .vertical {
            flex-direction: column;
        }
        .radiocontainer {
            font-size: 0.8em;
            display: flex;
            margin-right: 0.6rem;
            /*margin-bottom: 0.6rem;*/
            flex-direction: column;
            align-items: center;
            width: calc(100% / var(--optcount, 1))
        }
        .inline {
            flex-direction: row;
            width: fit-content;
        }
        .innerRadio-default {
            appearance: none;
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0;
        }
        .innerRadio-default::before {
            content: '\u{F043D}';
            font-family: "Material Design Icons";
            font-size: x-large;
            color: var(--pic-onSurfaceMediumColor, #666666);
            padding: 10px;
        }
        .innerRadio-default:disabled::before {
            color: var(--pic-radioDisabledColor);
        }
        .innerRadio-default:hover {
            background-color: var(--pic-radioHoverBGColor);
            border-radius: 50%;
        }
        .innerRadio-default:focus {
            background-color: var(--pic-radioActiveBGColor);
            border-radius: 50%;
            outline: none;
        }
        .innerRadio-default:active {
            background-color: var(--pic-radioActiveBGColor);
            border-radius: 50%;
            outline: none;
        }
        .innerRadio-default:checked::before {
            content: '\u{F043E}';
            font-family: "Material Design Icons";
            font-size: x-large;
            color: var(--pic-radioColor);
            padding: 10px;
        }
        .innerRadio-default:checked:disabled::before {
            color: var(--pic-radioDisabledColor);
        }
        .innerRadio-default:checked:hover {
            background-color: var(--pic-radioHoverBGColor);
            border-radius: 50%;
        }
        .innerRadio-default:checked:focus {
            background-color: var(--pic-radioActiveBGColor);
            border-radius: 50%;
            outline: none;
        }
        .innerRadio-default:checked:active {
            background-color: var(--pic-radioActiveBGColor);
            border-radius: 50%;
            outline: none;
        }
        .radio-option{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
        }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    focus() {
        this.inputField.focus();
    }
    doNothing(e) {
        return false;
    }
    validate() {
        if (this.required_ && !this.inputField.checked) {
            this.validState = [{ pass: false, failMessage: 'You must accept' }];
        }
        else {
            this.validState = [];
        }
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.initValue_ = this.submitValue;
    }
    dataReady() {
        if (this.value) {
            if (this.value.length > 0) {
                let ref = this;
                setTimeout(() => {
                    let tmpOpt = ref.optionContainer.getOption(ref.value);
                    if (tmpOpt) {
                        for (let i = 0; i < ref.radios.length; i++) {
                            let radio = ref.radios[i];
                            if (radio.id == tmpOpt.key)
                                radio.checked = true;
                        }
                    }
                    ref.requestUpdate();
                }, 20);
            }
        }
    }
    getRadioContainerStyle() {
        const align = this.eType == 'old' ? "align-items:unset" : "";
        let styles = [];
        if (ifDefined(align))
            styles.push({ 'align-items': 'unset' });
        if (this.maxWidth !== 0)
            styles.push({ 'max-width': this.maxWidth + 'px' });
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    renderRadio(iopt, index) {
        return html `
            <div density=${this.density} title=${iopt.val} style=${styleMap(this.getRadioContainerStyle())} class="radiocontainer ${this.density}">
                <label class=${classMap(this.getOptLabelClass())} for=${iopt.key}>${iopt.val}</label>
                <input name=${this.id_} id=${iopt.key} class="innerRadio ${this.eType == 'old' ? "" : "innerRadio-default"}" type="radio" ?checked=${this.eType == 'old' ? iopt.key == 'true' : iopt.key == this.value} ?disabled=${this.disabled_} @click=${this.changeHandler}>
            </div>
        `;
    }
    getOptLabelClass() {
        return {
            'pic-subtitle2': this.eType !== 'old',
            'radio-option': true
        };
    }
    getLabelClass() {
        return {
            'pic-subtitle1': this.eType !== 'old'
        };
    }
    getRadioClass() {
        return {
            'container': true,
            'groupcontainer': true,
            'horizontal': this.horizontal_ === true,
            'vertical': this.horizontal_ !== true,
        };
    }
    render() {
        this.setComponentInlineStyle();
        return html `
            ${this.renderCSS(true)}
            <style>
                input {
                    -webkit-user-select: auto;
                    -webkit-user-drag: none;
                    user-select: auto;
                }
            </style>
            <label class=${classMap(this.getLabelClass())} for="groupcontainer">${this.label}</label>
            <div 
                style="--optcount:${this.options.length};" 
                id="groupcontainer"
                class=${classMap(this.getRadioClass())}
                >
                ${repeat(this.options, (item, index) => this.renderRadio(item, index))}
            </div>
            ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
            ${this.renderErr(this.showFullError)}
        `;
    }
};
__decorate([
    query('.inner-input')
], PICRadio.prototype, "inputField", void 0);
__decorate([
    queryAll('.innerRadio')
], PICRadio.prototype, "radios", void 0);
__decorate([
    property({ reflect: true, attribute: 'horizontal', converter: booleanDecoder })
], PICRadio.prototype, "horizontal_", void 0);
__decorate([
    property({ converter: stringDecoderLC, attribute: 'etype' })
], PICRadio.prototype, "eType", void 0);
__decorate([
    property({ converter: stringDecoderLC, attribute: 'density' })
], PICRadio.prototype, "density", void 0);
__decorate([
    property({ type: Number, attribute: 'maxwidth' })
], PICRadio.prototype, "maxWidth", void 0);
PICRadio = __decorate([
    customElement('pic-radio')
], PICRadio);
export { PICRadio };
//# sourceMappingURL=PICRadio.js.map